module.exports = __webpack_public_path__ + "fonts/PRmiXeptR36kaC0GEAetxjBFCZ8rkaaoOvHyaB4p1V8.woff2";